// Canonical dental coverage categories. Keys must match backend values
// (see reShapeCostShareDental's coveragePercentByDentalCategory and the
// services `dental_category` column). Order is the display order used
// across eligibility cost-share grids and the service category picker.
export const DENTAL_CATEGORY_KEYS = ['Preventive', 'Basic', 'Major', 'Orthodontic', 'Other'];

// Label override: the service-category picker spells out "Other" so users
// understand it doubles as the non-covered bucket. Other surfaces (cost-share
// grids) keep the short label.
const DENTAL_CATEGORY_LABEL_OVERRIDES = {
  Other: 'Other / Non-covered'
};

export const DENTAL_CATEGORY_OPTIONS = DENTAL_CATEGORY_KEYS.map((key) => ({
  value: key,
  label: DENTAL_CATEGORY_LABEL_OVERRIDES[key] || key
}));
